import { lazy } from "react";

import Home from '../pages/home/home';
import Property from '../pages/property/property';
import Orders from '../pages/orders/orders';
import My from '../pages/my/my';

const Login = lazy(() => import('../pages/login/login'));
const P404 = lazy(() => import('../pages/layout/p404/p404'));

const Withdraw = lazy(() => import('../pages/my/withdraw/withdraw'));

const PropertyDetail = lazy(() => import('../pages/property/propertyDetail/propertyDetail'));
const BuyProperty = lazy(() => import('../pages/property/buyProperty/buyProperty'));

export const baseRout = [
  { path: "/login", name: 'login', component: Login, meta: { title: "登录" } },
  { path: "/404", name: 'p404', component: P404, meta: { title: "" } }
]

export const pageRoutList = [
  { 
    path: "/",
    name: 'home',
    component: Home,
    meta: { title: "电摩资产认购平台", isTab: true, }
  },
  { 
    path: "/property",
    name: 'property',
    component: Property,
    meta: { title: "资产管理", isTab: true, },
    children: [
      { path: '/propertyDetail', name: 'propertyDetail', component: PropertyDetail, meta: { title: "资产详情" } },
      { path: '/buyProperty', name: 'buyProperty', component: BuyProperty, meta: { title: "认购资产" } }
    ]
  },
  { 
    path: "/orders",
    name: 'orders',
    component: Orders,
    meta: { title: "订单管理", isTab: true, },
  },
  { 
    path: "/my",
    name: 'my',
    component: My,
    meta: { title: "收益管理", isTab: true, },
    children: [
      { path: '/withdraw', name: 'withdraw', component: Withdraw, meta: { title: "收入提现" } }
    ]
  }
]

export const routList = pageRoutList.concat(baseRout);